import person1 from 'modules/cp_membersAndPermissions/assets/images/person1.png';
import person2 from 'modules/cp_membersAndPermissions/assets/images/person2.png';
import person3 from 'modules/cp_membersAndPermissions/assets/images/person3.png';
import person4 from 'modules/cp_membersAndPermissions/assets/images/person4.png';

import EgyptIcon from 'modules/cp_membersAndPermissions/assets/icons/EgyptIcon';
import QatarIcon from 'modules/cp_membersAndPermissions/assets/icons/QatarIcon';
import SaudiArabiaIcon from 'modules/cp_membersAndPermissions/assets/icons/SaudiArabiaIcon';

export const members: any = [
  {
    id: 1,
    name: 'محمد مصطفي علي',
    img: person1,
    position: 'منصب العضو هنا',
    flag: <EgyptIcon />,
    status: 'outer',
    country: 'مصر',
  },
  {
    id: '01a8cdfa-95a4-4bf1-bad9-cb72af7009f8',
    name: 'GeneralSu pervisorgh gdfhfghfhjjfgh fgfghjgfjfghjgt',
    profilePicture: 'http://15.188.224.199:259/GDoc/Empty.png',
    userName: 'GeneralSupervisor',
    mobileNumber: '966523659874',
  },
  {
    id: 2,
    name: 'اسامة مجاهد',
    img: person2,
    position: 'منصب العضو هنا',
    flag: <QatarIcon />,
    status: 'outer',
    country: 'قطر',
  },
  {
    id: 3,
    name: 'احمد النواوي',
    img: person3,
    position: 'منصب العضو هنا',
    flag: <SaudiArabiaIcon />,
    status: 'inner',
    country: 'السعودية',
  },
  {
    id: 4,
    name: 'شريف خالد',
    img: person4,
    position: 'منصب العضو هنا',
    flag: <SaudiArabiaIcon />,
    status: 'inner',
    country: 'السعودية',
  },
  {
    id: 5,
    name: 'سيف ياسر',
    img: person4,
    position: 'منصب العضو هنا',
    flag: <SaudiArabiaIcon />,
    status: 'inner',
    country: 'السعودية',
  },
];
